import { NgModule } from '@angular/core';
import { KoguiapiComponent } from './koguiapi.component';

@NgModule({
  declarations: [KoguiapiComponent],
  imports: [
  ],
  exports: [KoguiapiComponent]
})
export class KoguiapiModule { }
